import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  setPage,
  performRequest,
  setSelectedProjectThemeTag,
  setThemeCategory,
} from './actions.mjs';
import ProjectFilterInfoText from './ProjectFilterInfoText.jsx';

class ProjectThemeFilters extends Component {
  filterResults(event, cat) {
    
    event.preventDefault();
    if (!this.props.loading) {
      this.props.dispatch(setThemeCategory(cat));
      this.props.dispatch(setSelectedProjectThemeTag(cat));

      this.props.dispatch(setPage(1));
      this.props.dispatch(
        performRequest({
          past: this.props.past,
          replace: true,
        })
      );
    }
  }

  removeFilters(event) {
    event.preventDefault();

    this.props.dispatch(
      performRequest({
        past: this.props.past,
        replace: true,
      })
    );
  }

  getClasses(hit) {
    if (this.props.selectedThemeTag === hit) {
      return 'btn-pill--pink active';
    }
    return 'btn-pill--pink';
  }

  render() {
    return (
      <div>
        <ProjectFilterInfoText infoText={this.props.translations.themeTabInfoText}></ProjectFilterInfoText>
        <nav className="nav nav-filters justify-content-center m-b-lg d-none d-md-flex">        
          <button
            onClick={event => this.filterResults(event, '')}
            className="btn-pill--pink"
          >
            {this.props.translations.allTabTitle}
          </button>
          {this.props.themeCategories.map((tag) => {
            return (
              <button
                key={tag.id}
                className={this.getClasses(tag.id)}
                onClick={(event) => this.filterResults(event, tag.id)}
              >
                {tag.name}
              </button>
            );
          })}
        </nav>
      </div>
      
    );
  }
}

function mapStateToProps(state) {
  return {
    hits: state.results.hits,
    themeCategories: state.themeCategories,
    loading: state.loading,
    selectedThemeTag: state.selectedThemeTag,
    translations: state.translations,
  };
}

export default connect(mapStateToProps)(ProjectThemeFilters);
